import { useCallback, useEffect, useState } from 'react'

// Memorise « l'utilisateur a ferme la bulle RINA de CETTE page » (S65).
//
// Portee VOLONTAIREMENT par page (`cle`) : la carte RINA sert d'en-tete
// explicatif, utile la premiere fois et encombrant ensuite. Fermer sur les
// Evenements ne doit donc pas la faire disparaitre du Compte, ou elle porte
// aussi le titre de la page. Une cle = une page.
//
// `localStorage` peut lever (Safari prive, stockage plein) : chaque acces est
// garde, et une lecture qui echoue laisse simplement la bulle visible.

const PREFIXE = 'lyannaj_rina_fermee_'

export default function useRinaFermee(cle) {
  const nomStockage = cle ? PREFIXE + cle : null

  const [fermee, setFermee] = useState(() => {
    if (!nomStockage) return false
    try {
      return localStorage.getItem(nomStockage) === '1'
    } catch {
      return false
    }
  })

  // La cle peut changer sans que le composant se demonte (une page qui suit
  // l'URL) : on relit l'etat memorise plutot que de garder celui d'avant.
  useEffect(() => {
    if (!nomStockage) { setFermee(false); return }
    try {
      setFermee(localStorage.getItem(nomStockage) === '1')
    } catch {
      setFermee(false)
    }
  }, [nomStockage])

  const basculer = useCallback((valeur) => {
    setFermee(valeur)
    if (!nomStockage) return
    try {
      if (valeur) localStorage.setItem(nomStockage, '1')
      else localStorage.removeItem(nomStockage)
    } catch { /* stockage indisponible : l'etat vaut pour la visite */ }
  }, [nomStockage])

  return {
    fermee,
    fermer: useCallback(() => basculer(true), [basculer]),
    rouvrir: useCallback(() => basculer(false), [basculer]),
  }
}
